import { render, staticRenderFns } from "./WorkflowInvocationDetails.vue?vue&type=template&id=562bbb79&"
import script from "./WorkflowInvocationDetails.vue?vue&type=script&setup=true&lang=js&"
export * from "./WorkflowInvocationDetails.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports